import { Outlet } from "react-router-dom";
import { ScrollTop } from "@/components/commons/ScrollTop";
import { InitSetupProvider } from "@/providers/InitSetupProvider";
import { LoadingArea } from "@/components/elements/Loading/Loading";
import { MobileLayoutProps } from "@/components/layout/MobileLayout/MobileLayout.types";
import { MobileBottomNav } from "@/components/layout/MobileLayout/MobileBottomNav";
import { LayoutShell, LayoutRoot, SafeAreaTop, MainContainer } from "@/components/layout/MobileLayout/mobile-layout.styles";

export const MobileLayout = ({ bottomNav = false, isLoading, children }: MobileLayoutProps) => {
  const content = (
    <LayoutShell>
      <LayoutRoot>
        <ScrollTop />
        <SafeAreaTop />
        <MainContainer>
          {isLoading ? (
            <LoadingArea />
          ) : (
            <>
              <Outlet />
              {children}
            </>
          )}
        </MainContainer>
      </LayoutRoot>
      {bottomNav && <MobileBottomNav />}
    </LayoutShell>
  );

  if (bottomNav) {
    return <InitSetupProvider>{content}</InitSetupProvider>;
  }

  return content;
};

export default MobileLayout;
